import React from "react";

export default function UnauthorizedScreen() {
  return <div>This user is not invited to the platform.</div>;
}
